import Swal from 'sweetalert2';
import { unity, regional, business, directory } from '../../modules/select';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_title: 'Atenção!',
    modal_text: 'Preencha os campos obrigatórios',
  },
  en: {
    modal_title: 'Warning!',
    modal_text: 'Please fill out all the Fields correctly',
  },
  es: {
    modal_title: '¡Atención!',
    modal_text: 'Rellene los campos obligatorios',
  },
};

export const profilesRede = () => {
  regional();
  unity();
  business();
  directory();
  validate();
};

const validate = () => {
  const $form = document.getElementById('form');
  const $directory = document.getElementById('directory_id');
  const $regional = document.getElementById('regional_id');
  const $unity = document.getElementById('unity_id');
  const $business = document.getElementById('business_id');
  const $leadership = document.getElementById('leadership');

  $form.addEventListener('submit', e => {
    if (!$directory.value || !$regional.value || !$unity.value || !$business.value || !$leadership.value) {
      e.preventDefault();
      Swal.fire(tr[lang].modal_title, tr[lang].modal_text, 'error');
    }
  });
};
